module.exports = __webpack_public_path__ + "static/media/pf27.d723501b.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf27.png
// module id = 2661
// module chunks = 0